window.Products.Bag.DrawstringBag = function () {}
window.Products.Bag.DrawstringBag.inherits(window.Products.Bag.Bag)